export default __webpack_public_path__ + "static/media/workcafe-2.acd10691.JPG";